<!-- Anonymous Toggle Button -->
<button
  class="btn mr-2"
  ngbTooltip="{{_(KEYS.CRUD.ANONYMOUS_ALLOCATION)}}"
  [disabled]="patientUid"
  *ngIf="showAnonymousToggle"
  [ngClass]="{'btn-primary': !isAnonymous, 'btn-success': isAnonymous}"
  (click)="onToggleAnonymous()"
>
  <i class="fa fa-user-secret"></i>
</button>

<!-- Pseudonymous Toggle Button -->
<button
  class="btn mr-2"
  ngbTooltip="{{_(KEYS.CRUD.PSEUDONYMOUS_ALLOCATION)}}"
  [disabled]="patientUid"
  *ngIf="showAnonymousToggle"
  [ngClass]="{'btn-primary': !isPseudonymous, 'btn-success': isPseudonymous}"
  (click)="onTogglePseudonymous()"
>
  <i class="fa fa-user-o"></i>
</button>

<!-- Save Button -->
<button
  id="saveBtn"
  class="btn btn-primary"
  [disabled]="isSaveDisabled"
  (click)="onSave()"
>
  <i class="fa fa-save"></i>
  {{_(KEYS.CRUD.SAVE_ASSIGN)}}
</button>

<span *ngIf="true" class="vl">&nbsp;</span>

<!-- Jump-In Code Button -->
<button
  class="btn btn-success"
  (click)="onCreateJumpInCode()"
  ngbTooltip="{{_(KEYS.CRUD.CREATE_JUMP_IN_CODE)}}"
  [disabled]="isJumpInCodeDisabled"
>
  <i class="fa fa-keyboard-o"></i>
</button>

<span *ngIf="showLinkSeparator" class="vl">&nbsp;</span>

<!-- Fill Start Button -->
<button
  *ngIf="feature.patient.app.link.open"
  class="btn btn-success mr-2"
  (click)="onFillStart()"
  [disabled]="isLinkActionsDisabled"
>
  <i class="fa fa-edit"></i>
  {{_(KEYS.CRUD.FILL_OUT_DIRECTLY)}}
</button>

<!-- Copy Link Button -->
<button
  *ngIf="feature.patient.app.link.copy"
  class="btn btn-success mr-2"
  (click)="onCopyLink()"
  [disabled]="isLinkActionsDisabled"
>
  <i class="fa fa-copy"></i>
  {{_(KEYS.CRUD.COPY_LINK)}}
</button>

<!-- Send Mail Button -->
<button
  class="btn btn-success"
  (click)="onSendMail()"
  *ngIf="patientUid && feature.patient.app.link.send && selectedQuestionnaires.length"
>
  <i class="fa fa-envelope"></i>
  {{_(KEYS.CRUD.SEND_LINK)}}
</button>

<!-- Close Window Button -->
<span class="vl" *ngIf="showCloseWinBtn">&nbsp;</span>
<button class="btn btn-success" id="closeWinBtn" *ngIf="showCloseWinBtn">
  <i class="fa fa-close"></i> {{_(KEYS.CRUD.CLOSE_WINDOW)}}
</button>
